<template>

</template>

<script>

export default {

  created() {
    this.$router.push("/");
  },

};
</script>



// WEBPACK FOOTER //
// src/components/product/ProductHome.vue